import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Select} from 'antd';
import {toJS} from 'mobx';
import styles from '../style.module.scss';
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';
import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react';

interface Props {
  isSubscriber: boolean;
  isCompetitorsTable: boolean;
  setFilteredCompetitorsData: React.Dispatch<React.SetStateAction<any[]>>;
  setCompetitors: React.Dispatch<React.SetStateAction<any[]>>;
  setActiveKw: React.Dispatch<React.SetStateAction<string>>;
  activeKw: string;
}

export const KeywordSelector = observer(({isSubscriber, isCompetitorsTable, setFilteredCompetitorsData, setActiveKw, setCompetitors, activeKw}: Props) => {
  const {Option} = Select;
  const {contentOptimizer: {currentPage}} = useStore('');

  const handleOnSelectChange = value => {
    setActiveKw(value);
    setCompetitors(toJS(currentPage?.analytics?.competitorsData)?.filter(item => item.keyword === value)[0]?.competitors);
    if (isCompetitorsTable) {
      setFilteredCompetitorsData(toJS(currentPage?.analytics?.competitorsData)?.filter(item => item.keyword === value)[0]?.competitors);
    }
  };

  return <KeywordDropdownWrapper>
    <span style={{marginLeft: '10px', marginBottom: '10px', color: '#4E5156', fontSize: '14px'}}>
        Keyword:
    </span>
    <Select
      disabled={!isSubscriber}
      value={`${activeKw}`}
      defaultValue={activeKw}
      onSelect={value => handleOnSelectChange(value)}
      dropdownStyle={{minWidth: '150px', fontSize: '12px'}}
      dropdownClassName={styles.keywordDropdownList}
      className={styles.selectInput}
      suffixIcon={<FontAwesomeIcon icon={faCaretDown} style={{color: '#000'}}/>}
    >
      {toJS(currentPage?.analytics?.competitorsData)?.map(item => {
        return <Option key={item.keyword} value={item.keyword}>{item.keyword}</Option>;
      })}

    </Select>
  </KeywordDropdownWrapper>;
});

const KeywordDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
